import { CircularProgress, Grid, GridSpacing, makeStyles } from '@material-ui/core';
import React from 'react';

interface Props {
  spacing?: GridSpacing;
  progressColor?: 'primary' | 'secondary' | 'inherit';
  size?: number | string;
}

const LoadingContainer: React.FC<Props> = ({
  spacing = 2,
  progressColor = 'primary',
  size = 40,
}) => {
  const classes = useStyles();

  return (
    <Grid
      className={classes.container}
      container
      justify="center"
      alignItems="center"
      spacing={spacing}
    >
      <Grid item>
        <CircularProgress variant="indeterminate" disableShrink color={progressColor} size={size} />
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    margin: 0,
  },
}));

export default LoadingContainer;
